import {Component, ElementRef, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {Subscription, timer} from 'rxjs';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {AuthService} from '../../services/auth.service';
import {TokenService} from '../../token.service';
import {TranslateService} from '@ngx-translate/core';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {NzMessageService} from 'ng-zorro-antd/message';
import { CryptoStorageService } from '@services/storage-service.service';
import jwtDecode from 'jwt-decode';
// import { startCountdown } from 'dbp-channels-business-toolboxify'
// analytics
import amplitude from 'amplitude-js';
import {ICustomer} from '../../interfaces/company.interface';

declare var $: any;
declare global {   interface Window {     runApplet: (appletName: string, config: any, token: any) => void;   } }
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  amplitudeInstance = amplitude.getInstance();
  tabs = [
    { key: 'phone', title: this.translateService.instant('HOME.LOGIN_PAGE.LOGIN_BY_PHONE') },
    { key: 'token', title: this.translateService.instant('HOME.LOGIN_PAGE.LOGIN_BY_TOKEN') },
  ];
  activeTab = 'phone';
  loginForm: FormGroup;
  passwordVisible: boolean;
  selectedCompany: number = null;
  step = 0;
  smsTimer = 5;
  deviceCode: string;
  isLoading = false;
  smsTimerCountDown: Subscription;
  expireTimeInSeconds = 30;
  companyList: ICustomer[] = [];
  sms = null;
  timer = this.expireTimeInSeconds;
  authData: any;
  decoded: any;
  referrer: string = null;
  shouldSendToReferrer = false;
  tokenPeriod = 1;
  isAkKamalAvailable: boolean = !!localStorage.getItem('AkKamalAvailable');

  constructor(
    private authService: AuthService,
    private router: Router,
    private tokenService: TokenService,
    private msg: NzMessageService,
    private readonly translateService: TranslateService,
    private message: NzNotificationService,
    private cryptoStorageService: CryptoStorageService,
    private renderer: Renderer2, private el: ElementRef
  ) {
    this.loginForm = new FormGroup({
      phoneNumber: new FormControl(null, Validators.required),
      password: new FormControl(null, Validators.required)
    });
  }

  ngOnInit(): void {
    this.loginForm.controls.password.setValue('');
    const passwordControl = this.el.nativeElement.querySelector('[formControlName="password"]');
    if (passwordControl) {
      this.renderer.setProperty(passwordControl, 'type', 'password');
    }

    this.referrer = window.document.referrer;
    this.shouldSendToReferrer = false;
    this.loginWithAkkamal();
    this.amplitudeInstance.init('02e1e0d0bd7f65d65646e12473135482');
    this.smsTimerCountDown = timer(0, 1000).subscribe(() => {
      --this.smsTimer;
    });
  }
  btnEnterHandler(): void {
    window.runApplet('', '/', this.tokenPeriod);
  }
  setActivaTab(key: string, index: number): void {
    this.activeTab = key;
  }

  clearAutoFillValues(): void {
    setTimeout(() => {
      this.loginForm.reset();
    }, 100);
  }

  login(): void {
    if (!JSON.parse(localStorage.getItem('AkKamalClient'))){
      localStorage.removeItem('AkKamalClient');
      for (const i in this.loginForm.controls) {
        if (this.loginForm.controls.hasOwnProperty(i)) {
          this.loginForm.controls[i].markAsDirty();
          this.loginForm.controls[i].updateValueAndValidity();
        }
      }
      if (this.loginForm.invalid) {
        return;
      }
      this.isLoading = true;
      const formValue = this.loginForm.value;
      this.authService.getCompanys(formValue.phoneNumber, formValue.password).subscribe(res => {
        if (res.body) {
          const {success, org} = res.body;
          if (success) {
            this.amplitudeInstance.logEvent('Session_Start_WEB', res.body);
            this.authData = formValue;
            const companyList = org && org.length > 0 ? org[0].cust_list : [];
            this.companyList = companyList.map(el => {
              return {
                bin: el.bin,
                custname: el.custname,
                division: el.division,
                pcustomer: el.pcustomer,
                client_code: el.clientCode,
                code: el.code
              };
            });
            this.selectedCompany = this.companyList && this.companyList.length > 0 ? this.companyList[0].pcustomer : null;
            localStorage.setItem('AUTH_METHOD', 'web');
            this.cryptoStorageService.setToSessionStorage('A_DATA', {phoneNumber: formValue.phoneNumber});
            this.cryptoStorageService.setToSessionStorage('U_COMPANIES', this.companyList);
            this.step = 2;
            if (this.companyList.length === 1) {
              this.selectCompany();
            }
          } else {
            this.message.error('Ошибка авторизации', res.body.reason);
            this.loginForm.setErrors({invalid_credentials: true});
          }
          this.isLoading = false;
        } else {
          this.message.error('Ошибка авторазации', 'Нет доступных компаний');
          this.isLoading = false;
          this.step = 1;
        }
      }, err => {
        this.message.error(err.statusText, 'Не удалось получить список компаний');
        this.isLoading = false;
      });
    }
  }

  isPasswordVisible(): void {
    this.passwordVisible = !this.passwordVisible;
  }

  onPasswordFocus(input: HTMLInputElement): void {
    input.removeAttribute('type');
  }

  onPasswordBlur(input: HTMLInputElement): void {
    input.setAttribute('type', this.passwordVisible ? 'text' : 'password');
  }

  ngOnDestroy(): void {
  }

  selectCompany(): void {
    if (!JSON.parse(localStorage.getItem('AkKamalClient'))){
      localStorage.removeItem('AkKamalClient');
      this.isLoading = true;
      const companyData = this.companyList.find(el => el.pcustomer === this.selectedCompany);
      const authData = this.authData;
      authData.client_idn = companyData.bin;
      authData.client_customerId = companyData.pcustomer;
      this.cryptoStorageService.setToSessionStorage('S_COMPANY', companyData);
      /*На выборе компании, проверяем необходимость двуфакторной авторизации*/
      this.authService.loginWithDeviceId(authData).subscribe((res) => {
          const {require_2fa} = res;
          if (require_2fa) {
            this.smsTimer = 60;
            /*Отображаем поле ввода смс, обновляем стейт authData с полями компании*/
            this.authData = authData;
            this.step = 3;
          } else {          /*Авторизуемся методом без требования 2фа*/
            if (res.access_token) {/*Проверяем, не пришел ли досрочно ответ авторизации*/
              this.tokenService.setToken(res);
              this.router.navigate(['portal/main']);
              this.referrer && this.shouldSendToReferrer ? window.location.href = this.referrer : this.router.navigate(['portal/main']);
            } else {
              this.loginWithOut2fa(authData);
            }
          }
          this.isLoading = false;
        },
        error => {
          console.log(error);
          this.isLoading = false;
          this.loginForm.setErrors({invalid_credentials: true});
        });
    }
  }

  loginWithAkkamal(): void {
    fetch('/auth/auth/realms/bank/protocol/openid-connect/token', {
      method: 'POST',
      body: 'grant_type=password&client_id=dbp-channels-business-akkamal&app_code=pre_session&action_code=login&type=new',
      headers:  {
        accept: 'application/json, text/plain, */*',
        'accept-language': 'ru-RU,ru;q=0.9,en-US;q=0.8,en;q=0.7',
        'content-type': 'application/x-www-form-urlencoded',
        'sec-ch-ua': '\"Not_A Brand\";v=\"8\", \"Chromium\";v=\"120\", \"Google Chrome\";v=\"120\"',
        'sec-ch-ua-mobile': '?0',
        'sec-ch-ua-platform': '\"Windows\"',
        'sec-fetch-dest': 'empty',
        'sec-fetch-mode': 'cors',
        'sec-fetch-site': 'same-origin',
        device_id: localStorage.getItem('uuid')
    },
    })
    .then(res => res.json())
    .then(token => {
      if (token.access_token) {
        localStorage.setItem('AkKamalClient', 'true');
        this.tokenService.setToken(token);
        this.decoded = jwtDecode(token.access_token);
        const organizations = this.decoded.provider_response.user_info.organization;
        if (this.authData?.phoneNumber) {
          this.cryptoStorageService.setToSessionStorage('A_DATA', {phoneNumber: this.authData.phoneNumber});
        }
        this.cryptoStorageService.setToSessionStorage('U_COMPANIES', [{
          custname: organizations.customerName,
          bin: organizations.idn,
          pcustomer: organizations.customerId,
          client_code: organizations.cliCode,
          code: '',
          division: ''
        }]);
        this.cryptoStorageService.setToSessionStorage('S_COMPANY', {
          custname: organizations.customerName,
          bin: organizations.idn,
          pcustomer: organizations.customerId,
          client_code: organizations.cliCode,
          code: '',
          division: ''
        });
        this.router.navigate(['portal/main']);
      }
    });
    // this.authService.loginWithAkkamal().subscribe((token) => {
    //   if (token.access_token) {
    //     this.tokenService.setToken(token);
    //     this.router.navigate(['portal/main']);
    //   }
    // });
  }
  loginWithOut2fa(authData): void {
    if (!JSON.parse(localStorage.getItem('AkKamalClient'))){
      localStorage.removeItem('AkKamalClient');
      this.isLoading = true;
      this.authService.login(authData).subscribe((token) => {
          this.isLoading = false;
          if (token.access_token) {
            this.tokenService.setToken(token);
            this.referrer && this.shouldSendToReferrer ? window.location.href = this.referrer : this.router.navigate(['portal/main']);
          } else {
            this.message.error('Неверный код проверки', 'Проверьте введеный код');
            this.isLoading = false;
          }
        },
        error => {
          this.isLoading = false;
          this.loginForm.reset();
          this.step = 1;
          this.companyList = [];
          this.selectedCompany = null;
          this.loginForm.setErrors({invalid_credentials: true});
        });
    }
  }
  loginWith2fa(): void {
    if (!JSON.parse(localStorage.getItem('AkKamalClient'))){
      localStorage.removeItem('AkKamalClient');
      const authData = this.authData;
      authData.sms_code = this.sms;
      this.isLoading = true;
      this.authService.loginWith2fa(authData).subscribe((token) => {
          this.isLoading = false;
          if (!!token.access_token) {
            this.tokenService.setToken(token);
            this.router.navigate(['portal/main']);
            this.referrer && this.shouldSendToReferrer ? window.location.href = this.referrer : this.router.navigate(['portal/main']);
          } else {
            this.message.error('Ошибка авторизации', token.reason);
          }
        },
        error => {
          this.isLoading = false;
          this.loginForm.setErrors({invalid_credentials: true});
        });
    }
  }

  checkValidLogin(e): void {
    e.preventDefault();
    localStorage.removeItem('AkKamalClient');
    if (this.loginForm.controls.phoneNumber.valid) {
      this.step = 1;
    }
  }

  backTologinField(): void {
    this.step = 0;
    this.loginForm.controls.password.reset();
  }

  checkValidNumber(): boolean {
    return this.loginForm.controls.phoneNumber.valid;
  }

  checkFormValid(): boolean {
    return this.loginForm.valid;
  }

  goToRecovery(): void {
    window.location.href = `/access-recovery-ui?phoneNumber=${this.loginForm.controls.phoneNumber.value}`;
  }
}
